export function delay(ms: number, signal?: AbortSignal): Promise<void> {
	return new Promise((resolve) => {
		if (signal?.aborted) {
			resolve()
			return
		}
		const finish = () => {
			clearTimeout(timer)
			signal?.removeEventListener('abort', finish)
			resolve()
		}
		const timer = window.setTimeout(finish, ms)
		signal?.addEventListener('abort', finish, { once: true })
	})
}
